
import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import type { CaseStudy } from '../types';
import { ArrowRight, BookOpen } from 'lucide-react';

export const CaseStudyLink: React.FC<{ caseStudy: CaseStudy }> = ({ caseStudy }) => (
  <section className="py-16 bg-bkg-light dark:bg-bkg-dark">
    <div className="container mx-auto px-4 max-w-4xl">
      <div className="bg-content-light dark:bg-content-dark p-8 md:p-12 rounded-2xl shadow-lg border border-border-light dark:border-border-dark text-center">
        <BookOpen className="w-12 h-12 mx-auto text-primary-light dark:text-primary-dark mb-4" />
        <h2 className="text-3xl font-bold mb-2">Zobacz w akcji</h2>
        <p className="text-lg text-text-secondary-light dark:text-text-secondary-dark mb-6">
          Przeczytaj case study {caseStudy.clientName} i odkryj, jak nasze rozwiązanie przyniosło realne rezultaty.
        </p>
        <ReactRouterDOM.Link 
          to={`/case-studies#${caseStudy.id}`}
          className="font-semibold text-primary-light dark:text-primary-dark inline-flex items-center group text-lg"
        >
          Zobacz Case Study <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
        </ReactRouterDOM.Link>
      </div>
    </div>
  </section>
);
